<template>
  <v-layout column>
    <v-flex sm12>
      <v-card class="card">
        <v-card-title primary-title class="justify-center">
          <h3 class="headline mb-0">Seja muito bem-vindo!</h3>
        </v-card-title>
        <v-card-text>
          <v-container class="pt-0">
            <v-form>
              <v-text-field
                v-model="usuario.login"
                name="login"
                label="Informe seu login ou email"
                type="text"
                prepend-icon="fa fa-user"
                :error-messages="loginErrors"
              ></v-text-field>
              <v-text-field
                v-model="usuario.password"
                name="password"
                label="E sua senha"
                type="password"
                prepend-icon="fa fa-lock"
                :error-messages="passwordErrors"
              ></v-text-field>
              <v-btn
                type="submit"
                @click.prevent="login"
                :disabled="$v.$anyError"
                color="primary"
                block
              >
                Entrar
              </v-btn>
              <v-btn
                class="mt-3"
                :to="{ name: 'cadastro' }"
                color="primary"
                block
              >
                Faça seu cadastro
              </v-btn>
            </v-form>
            <v-btn
              class="mt-3"
              :to="{ name: 'resetarSenha' }"
              color="primary"
              block
            >
              Esqueci minha senha
            </v-btn>
            <address class="mt-3">
              <p>
                Contato:
                <a href="mailto:contato@appquiz.com.br">
                  contato@appquiz.com.br
                </a>
                <br />
                Telefone: <a href="tel:92-3042-0150">(92) 3042-0150</a>
              </p>
            </address>
          </v-container>
        </v-card-text>
      </v-card>
    </v-flex>
  </v-layout>
</template>
<script>
import { required } from "vuelidate/lib/validators";
export default {
  name: "FormLogin",
  data() {
    return {
      usuario: {
        login: "",
        password: "",
      },
    };
  },
  computed: {
    loginErrors() {
      const errors = [];
      if (!this.$v.usuario.login.$dirty) return errors;
      !this.$v.usuario.login.required && errors.push("Campo obrigatorio.");
      return errors;
    },
    passwordErrors() {
      const errors = [];
      if (!this.$v.usuario.password.$dirty) return errors;
      !this.$v.usuario.password.required && errors.push("Campo obrigatorio.");
      return errors;
    },
  },
  validations: {
    usuario: {
      login: { required },
      password: { required },
    },
  },
  methods: {
    login() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.$store
          .dispatch("login", {
            login: this.usuario.login,
            password: this.usuario.password,
          })
          .then(() => {
            this.$router.push("/pontosPesquisa");
          });
      }
    },
  },
};
</script>

<style scoped>
.v-layout {
  top: -70%;
}
</style>
